import React, {forwardRef, useState } from "react";
import MaterialTable, { MTableBodyRow } from '@material-table/core';
import { Refresh } from '@mui/icons-material';
//import CustomTable from './customTable';
import Box from '@mui/material/Box';

//  TODO: 
//  - Style capnr with color when they use more colors caps:
//    - Add coding to get eventContext and event
//    - Add Theme
//    - Check if more then one color is used -> haveColor
//    - Check if color is part of the objects in the 'actives' collection (otherwise fix it in activesService)
//    - Add this to the column definition: 
//  cellStyle: (e, rowData) => {
//  if (haveColor) {
//    return { backgroundColor: 'capColorBackground.'+rowData.color , color: 'capColorText.'+rowData.color };
//  }
// },
const ActivesList = ({actives, refreshTable, selectParticipant}) => {
    const [selectedRowId, setSelectedRowId] = useState(null)

    return (
      <Box id="ZwemtNogList" sx={{ mt: 1}}>
      <MaterialTable
        // icons={tableIcons}
        localization={{
          pagination: {
            labelDisplayedRows: '{from}-{to} van {count}',
            labelRowsSelect: 'Rijen',
            labelRowsPerPage: 'Rijen per pagina:',
            firstAriaLabel: 'Eerste pagina',
            firstTooltip: 'Eerste pagina',
            previousAriaLabel: 'Vorige pagina',
            previousTooltip: 'Vorige pagina',
            nextAriaLabel: 'Volgende pagina',
            nextTooltip: 'Volgende pagina',
            lastAriaLabel: 'Laatste pagina',
            lastTooltip: 'Laatste pagina'
          },
          toolbar: {
            addRemoveColumns: 'Verwijder of voeg kolommen toe',
            nRowsSelected: '{0} rij(en) geselecteerd',
            showColumnsTitle: 'Toon kolommen',
            showColumnsAriaLabel: 'Toon kolommen',
            exportTitle: 'Export',
            exportAriaLabel: 'Export',
            exportName: 'Export als CSV',
            searchTooltip: 'Zoeken',
            searchPlaceholder: 'Zoeken'
            },
          header: {
              actions: 'Acties'
          },
          body: {
              emptyDataSourceMessage: 'Er zijn geen resultaten',
              filterRow: {
                  filterTooltip: 'Filter'
              }
          }
        }}
        options={{
          pageSize: 10,
          headerStyle: { position: 'sticky', top: 0, fontWeight: 'bold', color:"white", backgroundColor: '#019ce2' },
          rowStyle: (rowData, index) => ({
            backgroundColor:
              rowData.tableData.id === selectedRowId
                ? "#6ABAC9"
                : (index % 2) === 0 ? "#e1f3fc" : "#f2fafd"
          })
        }}
        title="Deelnemers"
        columns={[
          {
            title: "Cap",
            field: "capnr",
            hidden: true
          },
          {
            title: "Capnr",
            field: "displayCapnr",
            customSort: (a, b, type, direction) => { 
              return parseInt(a["displayCapnr"].replace(/\D/g, '')) - parseInt(b["displayCapnr"].replace(/\D/g, ''));
            }
          },
          {
            title: "Te water op",
            field: "startedAt"
          },
          {
            title: "Naam",
            field: "fullName"
          },
          {
            title: "Afstand",
            field: "distance"
          },
          {
            title: "Leeftijd",
            field: "age"
          },
        ]}
        data={actives}
        onRowClick={(event, rowData) => {
          // if the rowData.tableDate.id could be used on condidtional render
          console.log(rowData);
          setSelectedRowId(rowData.tableData.id);
          selectParticipant(rowData);
        }}
        actions={[
          {
            icon: () => <Refresh />,
            tooltip: 'Ververs data',
            isFreeAction: true,
            onClick: (event) => {setSelectedRowId(null); refreshTable()}
          }
        ]}
      />    
    </Box>
    );
  }

export default ActivesList;
